import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from './logging.service';
import { Observable } from 'rxjs';
import { Team } from '../models/team';
import { User } from '../models/user';
import { Params } from '@angular/router';
import { QuestionGroup } from '../models/questionGroup';
import { ApiService } from './api.service';
import { Tag } from '../models/tag';
import { Assignment } from '../models/assignment';
import { UserTagsResponse } from '../models/userTagResponse';
import { userRequest } from '../models/userRequest';
import { TeamRequest } from '../models/teamRequest';
import { Manager } from '../models/manager';
import { Password } from '../models/password';

@Injectable({
  providedIn: 'root'
})
export class ManagerDashboardService {

  private teams: Team[] = [];

  constructor(private httpClient : HttpClient, private apiService: ApiService,
              private loggingService : LoggingService) { }

  getAllTeams(managerId : number) : Observable<Team[]> {
    const params = {
      managerId : managerId
    };
    return this.httpClient.get<Team[]>(this.apiService.getUrl('hierarchy/teams/list'), {params : params});
  }

  getAllUsers(managerId : number, teamId : number, userRole : string) : Observable<User[]> {
    const params = {
      managerId : managerId,
      teamId : teamId,
      personType : userRole
    };
    return this.httpClient.get<User[]>(this.apiService.getUrl('user/list'), {params : params});
  }

  getAllQuestionGroup() : Observable<QuestionGroup[]> {
    return this.httpClient.get<QuestionGroup[]>(this.apiService.getUrl('question-group/question-groups'));
  } 

  getAllTags() : Observable<Tag[]> {
    return this.httpClient.get<Tag[]>(this.apiService.getGlobalUrl('question-group/tags'));
  }

  getAllDetails(managerId : number, userId : number, userRole : string) : Observable<User> {
    const params = {
      managerId : managerId,
      userId : userId,
      personType : userRole
    };
    this.loggingService.logDebug("Retrieving user details based on manager id "+ managerId +", user id "+ userId +" and user role "+ userRole);
    return this.httpClient.get<User>(this.apiService.getUrl('user/details'), {params : params});
  }

  getAllAssignmentByManagerId(managerId : number) : Observable<Assignment[]> {
    const params = {
      managerId : managerId
    };
    this.loggingService.logDebug("Retrieving all assignment assigned by manager id "+ managerId);
    return this.httpClient.get<Assignment[]>(this.apiService.getUrl('user-tag/assignment'), {params : params});
  }

  getAllUsersWithStatusByManagerIdAndTeamIdAndAssigmentId(managerId : number, teamId : number) : Observable<UserTagsResponse[]> {
    const params = {

      managerId : managerId,
      teamId : teamId,
    };
    this.loggingService.logDebug("Retrieving all users with status based on manager id "+ managerId + "team id " + teamId );
    return this.httpClient.get<UserTagsResponse[]>(this.apiService.getUrl('user-tag/user'), {params : params});
  }

  createUser(user : userRequest) : Observable<User> {
    this.loggingService.logDebug("create the user");
    return this.httpClient.post<User>(this.apiService.getUrl('user'), user);
  }

  createBulkUser(file: FormData, teamId: number, managerId: number): Observable<any> {
    this.loggingService.logDebug("create Bulk user");
    const params = {

      managerId: managerId,
      teamId: teamId,
    };
    return this.httpClient.post<User>(this.apiService.getUrl('user/bulk-import'), file, { params: params });
  }


  getManagerDetails(managerId : number) : Observable<Manager> {
    this.loggingService.logDebug("retrieving manager details based on manager id " + managerId);
    return this.httpClient.get<Manager>(this.apiService.getUrl(`hierarchy/managers/${managerId}`));
  }

  createTeam(team : TeamRequest) : Observable<Team> {
    this.loggingService.logDebug("create the team");
    return this.httpClient.post<Team>(this.apiService.getUrl('hierarchy/teams'), team);
  }

  updatePassword(password : Password) : Observable<any> {
    this.loggingService.logDebug("updating the password");
    return this.httpClient.put<any>(this.apiService.getUrl('user/updatePassword'), password);
  }


    setTeams(teams: Team[]) {
    this.teams = teams;
  }

   getTeams() {
    return this.teams;
  }

   getTeamById(teamId: number): Team | undefined {
    return this.teams.find(t => t.teamId === teamId);
  }



}
